import React, { createContext, useContext, ReactElement, useState, useEffect } from 'react';
import { authenticatedGetRequest } from '../services';
import { localStorageMethods } from '../pages/portal-pharmaceutical/common/helpers';
import { IPharmaceuticalCrendentials, LocalStorageKeysEnum } from '../pages/portal-pharmaceutical/common/contracts';

export type AuthContextState = {
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: any;
};

export type AuthProviderProps = {
  children: ReactElement;
};

const defaultState: AuthContextState = {
  isAuthenticated: false,
  isLoading: true,
  user: undefined,
};

export const AuthContext = createContext<AuthContextState>(defaultState);

export const AuthProvider = ({ children }: AuthProviderProps): JSX.Element => {
  const [state, setState] = useState<AuthContextState>(defaultState);

  useEffect(() => {
    async function runAsync() {
      try {
        const credentials = localStorageMethods.getItem<IPharmaceuticalCrendentials>(LocalStorageKeysEnum.PHARMACEUTICAL_CREDENTIALS);

        if (!credentials || !credentials?.access_token) {
          setState({
            ...defaultState,
            isLoading: false,
          });
          return;
        }

        const response = await authenticatedGetRequest('auth/user');
        
        if (!response || response?.data?.uuid !== credentials.healthPassportId) {
          setState({
            ...defaultState,
            isLoading: false,
          });
        } else {
          setState({
            isAuthenticated: true,
            isLoading: false,
            user: response.data,
          });
        }
      } catch (err) {
        console.log(err);
        setState({
          ...defaultState,
          isLoading: false,
        });
      }
    }
    runAsync();
  }, []);

  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
};

export const useAuth = (): AuthContextState => useContext<AuthContextState>(AuthContext);
